import type {FilterObject} from 'nutshell-core/types';

// Helper for filter bar to check if any filters are applied
export function checkIsFiltering(filters: FilterObject[], searchValue: string): boolean {
    // Archiving behaves like a filter, but we don't count it as one
    // (i.e, we don't want to show the 'Remove all filters' button when it's enabled)
    const isFiltering =
        Boolean(filters.length) && filters.some((filter) => Object.keys(filter)[0] !== 'archived');

    return isFiltering || Boolean(searchValue);
}
